/**
 * Created by Andriyanto.
 * E-Mail Address: 4lenour@gmail.com
 * Date: 06/12/2024
 */
import {defineAsyncComponent, markRaw} from "vue";

export const toolbox = {
    offCanvas: defineAsyncComponent(() =>
        import('./offcanvas/offcanvas.vue').then(res => markRaw(res.default))
    ),
    userAvatar: defineAsyncComponent(() =>
        import('./useravatar/useravatar.vue').then(res => markRaw(res.default))
    ),
    modal: defineAsyncComponent(() =>
        import('./modal/modal.vue').then(res => markRaw(res.default))
    ),
    textInput: defineAsyncComponent(() =>
        import('./form/text/textInput.vue').then(res => markRaw(res.default))
    ),
    emailInput: defineAsyncComponent(() =>
        import('./form/text/emailInput.vue').then(res => markRaw(res.default))
    ),
    phoneInput: defineAsyncComponent(() =>
        import('./form/text/phoneInput.vue').then(res => markRaw(res.default))
    ),
    textEditor: defineAsyncComponent(() =>
        import('./form/text/textEditor.vue').then(res => markRaw(res.default))
    ),
    textAreaInput: defineAsyncComponent(() =>
        import('./form/text/textareaInput.vue').then(res => markRaw(res.default))
    ),
    passwordInput: defineAsyncComponent(() =>
        import('./form/text/passwordInput.vue').then(res => markRaw(res.default))
    ),
    selectInput: defineAsyncComponent(() =>
        import('./form/select/selectInput.vue').then(res => markRaw(res.default))
    ),
    radioInput: defineAsyncComponent(() =>
        import('./form/radio/radioInput.vue').then(res => markRaw(res.default))
    ),
    checkboxInput: defineAsyncComponent(() =>
        import('./form/checkbox/checkboxInput.vue').then(res => markRaw(res.default))
    ),
    dateInput: defineAsyncComponent(() =>
        import('./form/datetime/dateInput.vue').then(res => markRaw(res.default))
    ),
    timeInput: defineAsyncComponent(() =>
        import('./form/datetime/timeInput.vue').then(res => markRaw(res.default))
    ),
    numberInput: defineAsyncComponent(() =>
        import('./form/number/numberInput.vue').then(res => markRaw(res.default))
    ),
    colorInput: defineAsyncComponent(() =>
        import('./form/color/colorInput.vue').then(res => markRaw(res.default))
    ),
    fileInput: defineAsyncComponent(() =>
        import('./form/file/fileInput.vue').then(res => markRaw(res.default))
    ),
    tab: defineAsyncComponent(() =>
        import('./tab/tab.vue').then(res => markRaw(res.default))
    ),
    tabPanel: defineAsyncComponent(() =>
        import('./tab/tabPanel.vue').then(res => markRaw(res.default))
    ),
    table2: defineAsyncComponent(() =>
        import('./table/table2.vue').then(res => markRaw(res.default))
    ),
    panel: defineAsyncComponent(() =>
        import('./panel/panel.vue').then(res => markRaw(res.default))
    ),
    calendar: defineAsyncComponent(() =>
        import('./form/datetime/calendar.vue').then(res => markRaw(res.default))
    )
}
